var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "list-group overflow-auto pr-1",
        staticStyle: { "max-height": "800px", "overflow-y": "auto" },
      },
      [
        _vm._l(_vm.members, function (member, index) {
          return _c("div", { key: index, staticClass: "card" }, [
            _c("div", { staticClass: "d-flex" }, [
              _c("div", { staticClass: "p-1" }, [
                _c("img", {
                  staticClass: "round",
                  attrs: {
                    src:
                      member.avatar !== null
                        ? member.avatar.url
                        : "/images/avatar.png",
                    alt: "avatar",
                    height: "40",
                    width: "40",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "pl-0 pt-1 pr-1 pb-1" }, [
                _c(
                  "div",
                  [
                    _c(
                      "a",
                      {
                        staticClass: "text-bold-600",
                        staticStyle: { color: "inherit" },
                        attrs: { href: "/member/profiles/" + member.username },
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(member.first_name) +
                            " " +
                            _vm._s(member.last_name) +
                            "\n                        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    member.roles[0].title === "Admin"
                      ? _c("img", {
                          staticStyle: { "margin-top": "-3px", height: "15px" },
                          attrs: {
                            src: "/images/badges/admin.png",
                            alt: "user role badge",
                            "data-toggle": "tooltip",
                            "data-placement": "bottom",
                            title: "Administrator",
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(member.badges, function (badge) {
                      return _c("img", {
                        staticStyle: { "margin-top": "-3px", height: "15px" },
                        attrs: {
                          src: badge.image,
                          alt: "user custom badge",
                          "data-toggle": "tooltip",
                          "data-placement": "bottom",
                          title: badge.name,
                        },
                      })
                    }),
                    _vm._v(" "),
                    member.user_badge_id !== null &&
                    member.user_badge_image != null
                      ? _c("img", {
                          staticStyle: { "margin-top": "-3px", height: "15px" },
                          attrs: {
                            src: member.user_badge_image.url,
                            alt: "user plan badge",
                            "data-toggle": "tooltip",
                            "data-placement": "bottom",
                            title: member.user_badge_name,
                          },
                        })
                      : _vm._e(),
                  ],
                  2
                ),
                _vm._v(" "),
                _c("span", { staticClass: "font-small-3 text-muted" }, [
                  _vm._v(
                    _vm._s(member.organisation) +
                      " | " +
                      _vm._s(member.position)
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "ml-auto p-1 mobile-hide text-center d-flex align-items-center",
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn-sm btn-outline-light",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.goProfile(member.username)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.__("group.form.buttons.view_profile")) +
                          " "
                      ),
                      _c("i", { staticClass: "feather icon-chevron-right" }),
                    ]
                  ),
                ]
              ),
            ]),
          ])
        }),
        _vm._v(" "),
        _c("infinite-loading", { on: { infinite: _vm.infiniteHandler } }, [
          _c("div", { attrs: { slot: "no-more" }, slot: "no-more" }),
          _vm._v(" "),
          _c("div", { attrs: { slot: "no-results" }, slot: "no-results" }),
        ]),
      ],
      2
    ),
    _vm._v(" "),
    _vm.members.length === 0
      ? _c("div", { staticClass: "card bg-outline-gray" }, [
          _c("div", { staticClass: "card-header" }, [
            _c("h4", { staticClass: "card-title gray" }, [
              _vm._v(_vm._s(_vm.__(_vm.type + ".no_members_header"))),
            ]),
            _vm._v(" "),
            _vm._m(0),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card-body" }, [
            _c("span", { staticClass: "gray" }, [
              _vm._v(_vm._s(_vm.__(_vm.type + ".no_members.content"))),
            ]),
            _vm._v(" "),
            _c("div", [
              _c("a", { attrs: { href: "/member/help" } }, [
                _c("button", { staticClass: "btn btn-outline-light mt-1" }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.__(_vm.type + ".form.buttons.help")) +
                      "\n                    "
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _vm._m(1),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      { staticClass: "heading-elements", attrs: { "data-action": "close" } },
      [_c("i", { staticClass: "feather icon-x" })]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ml-auto" }, [
      _c("img", {
        staticStyle: { float: "right", "margin-top": "-40px" },
        attrs: { src: "/images/annie.png", width: "50px", alt: "image" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }